import { SvgIconProps } from './icon-props';

export default function Edit({ height = 27, width = 27 }: SvgIconProps) {
	return (
		<svg
			viewBox="0 0 27 27"
			width={width}
			height={height}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.832.5a1 1 0 0 0-1.414 0L8.643 12.275a1 1 0 0 0-.282.56l-.733 4.942a1 1 0 0 0 1.129 1.137l4.976-.7a1 1 0 0 0 .568-.284L26.075 6.157a1 1 0 0 0 0-1.414L21.832.5Zm-.707.707 4.243 4.243-11.774 11.773-4.977.7.733-4.94L21.125 1.206ZM1 1.738a1 1 0 0 0-1 1v23a1 1 0 0 0 1 1h23a1 1 0 0 0 1-1v-11.5a.5.5 0 1 0-1 0v11.5H1v-23h11.086a.5.5 0 0 0 0-1H1Z"
				fill="#000"
			/>
		</svg>
	);
}
